import { useState } from "react";
import { Link } from "react-router-dom";

function Navbar({
  menuItems,
  onLogout,
  // brandText = "Schronisko Bartne",
  userRole = "user"
}) {
  const [menuOpen, setMenuOpen] = useState(false);
  const visibleItems = menuItems.filter((item) => {
    if (item.adminOnly) {
      return userRole === "admin";
    }
    if (item.moderatorOnly) {
      return userRole === "admin" || userRole === "moderator";
    }
    return true;
  });

  return (
    <>
      {/* No Navbar box, just the menu button absolutely positioned */}
      <button
        className="HamburgerButton"
        type="button"
        onClick={() => setMenuOpen(true)}
        aria-label="Otworz menu"
        aria-expanded={menuOpen}
        style={{
          position: "absolute",
          top: 12,
          left: 12,
          zIndex: 1000
        }}
      >
        <span className="HamburgerLines" />
      </button>

      <button
        className="HamburgerButton FloatingMenuButton"
        type="button"
        onClick={() => setMenuOpen(true)}
        aria-label="Otworz menu"
        aria-expanded={menuOpen}
      >
        <span className="HamburgerLines" />
      </button>

      {menuOpen ? (
        <div className="MenuOverlay" onClick={() => setMenuOpen(false)}>
          <div className="MenuPanel" onClick={(event) => event.stopPropagation()}>
            <div className="MenuHeader">
              <p className="MenuTitle">Menu</p>
              <button
                className="MenuClose"
                type="button"
                onClick={() => setMenuOpen(false)}
                aria-label="Zamknij menu"
              >
                ×
              </button>
            </div>
            <ul className="MenuList">
              {visibleItems.map((item, index) => (
                <li key={item.label || `divider-${index}`}>
                  {item.type === "divider" ? (
                    <span className="MenuDivider" aria-hidden="true" />
                  ) : item.to ? (
                    <Link
                      className="MenuItem"
                      to={item.to}
                      onClick={() => setMenuOpen(false)}
                    >
                      {item.label}
                    </Link>
                  ) : (
                    <button
                      className="MenuItem"
                      type="button"
                      onClick={() => {
                        setMenuOpen(false);
                        if (item.action === "logout" && onLogout) {
                          onLogout();
                        }
                      }}
                    >
                      {item.label}
                    </button>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      ) : null}
    </>
  );
}

export default Navbar;
